import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import Seccion1 from './Seccion1/S1';
import Seccion3 from './Seccion3/S3';
import CeluSeccion3 from './CeluSeccion3/S3';
import ContactSection from './Seccion4/S4'; // Importa el nuevo componente
import styled, { keyframes } from 'styled-components';
import Footer from '../Home/Footer/Footer';

// Animación para la aparición del texto
const appear = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const SectionContainer = styled.div`
  animation: ${appear} 0.5s ease-in-out forwards;
  animation-delay: ${props => props.delay}s;
  opacity: 0;
`;

function PuntajesInfo() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id='puntajes-info'>
      {isMobile ? (
        <>
          <SectionContainer delay={0}>
            <Seccion1 />
          </SectionContainer>
          <SectionContainer delay={0.5}>
            <CeluSeccion3 />
          </SectionContainer>
          
        </>
      ) : (
        <>
          <SectionContainer delay={0}>
            <Seccion1 />
          </SectionContainer>
          <SectionContainer delay={0.5}>
            <Seccion3 />
          </SectionContainer>
          
        </>
      )}
      <SectionContainer delay={1}>
        {/*<ContactSection /> {/* Usa el nuevo componente */}
      </SectionContainer>
      <Footer />
    </div>
  );
}

export default PuntajesInfo;
